import React from 'react';

import { SVGComponentProps } from './svg.types';

const TimerSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M5.83331 1.1665H8.16665"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 8.1665L8.75 6.4165"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.99998 12.8333C9.57731 12.8333 11.6666 10.744 11.6666 8.16667C11.6666 5.58934 9.57731 3.5 6.99998 3.5C4.42265 3.5 2.33331 5.58934 2.33331 8.16667C2.33331 10.744 4.42265 12.8333 6.99998 12.8333Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default TimerSVG;
